module.exports = __webpack_public_path__ + "static/media/About.d65ee8be.jpg";